import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PaperPlaneRight } from "@phosphor-icons/react";
import { fmtDateTime } from "./render";

// Envoi du brouillon enregistré à une seule adresse (objet préfixé [TEST], sans suivi, sans effet sur les prospects).
export function TestSendDialog({ open, onClose, c, reload }) {
  const [to, setTo] = useState("");
  const [key, setKey] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setTo(c.admin_email || ""); setKey(c.recipients[0]?.key || ""); } }, [open, c.admin_email, c.recipients]);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/leads/campaigns/${c.id}/test-send`, { to, key: key || undefined });
      toast.success(`Email de test envoyé à ${data.to}`); reload(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const tests = (c.tests || []).slice(-3).reverse();
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-surface border-border w-[95vw] max-w-md" data-testid="lead-test-send-dialog">
        <DialogHeader>
          <DialogTitle>M'envoyer un test</DialogTitle>
          <DialogDescription>Le brouillon enregistré est envoyé à cette seule adresse, objet préfixé « [TEST] ». Aucun prospect n'est contacté.</DialogDescription>
        </DialogHeader>
        <label className="text-xs text-muted">Adresse de test</label>
        <Input type="email" value={to} onChange={(e) => setTo(e.target.value)} className="bg-surface-2 border-border" data-testid="lead-test-send-to" />
        <label className="text-xs text-muted">Variables remplies comme pour</label>
        <select value={key} onChange={(e) => setKey(e.target.value)} className="bg-surface-2 border border-border rounded-md text-sm px-2 py-2" data-testid="lead-test-send-as">
          {c.recipients.map((r) => <option key={r.key} value={r.key}>{r.contact_name || r.email} — {r.company}</option>)}
          {!c.recipients.length && <option value="">un contact fictif (Camille Martin, Exemple SAS)</option>}
        </select>
        {tests.length > 0 && (
          <div className="text-[11px] text-muted" data-testid="lead-test-send-history">Derniers tests : {tests.map((t) => `${t.to} (${fmtDateTime(t.at)})`).join(" · ")}</div>
        )}
        <button onClick={send} disabled={busy || !to.trim()} className="bg-accent text-black font-semibold rounded-md py-2.5 text-sm flex items-center justify-center gap-1.5 disabled:opacity-50" data-testid="lead-test-send-confirm">
          <PaperPlaneRight size={14} /> {busy ? "Envoi…" : "Envoyer le test"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
